export const LIST_MODULECODE_MAP = {
  '/list': 'RDPI_search_all',
}



export const DETAIL_DATASETCODE_MAP = {
  /* 专家 */
  'ruc_person': { path: '/detail', moduleCode: 'RDPI_detail_person', listPath: '/list?moduleCode=RDPI_search_person', title: '军政人事', listTitle:'军政人事' },
  /* 文献详情 */
  'ruc_journal_paper': { path: '/detail', moduleCode: 'RDPI_detail_journal_paper', listPath: '/list?moduleCode=RDPI_search_jywx', title: '期刊论文', listTitle:'文献' },
  'ruc_meeting': { path: '/detail', moduleCode: 'RDPI_detail_meeting', listPath: '/list?moduleCode=RDPI_search_jywx', title: '会议论文', listTitle:'文献' },
  'ruc_degree': { path: '/detail', moduleCode: 'RDPI_detail_degree', listPath: '/list?moduleCode=RDPI_search_jywx', title: '学位论文', listTitle:'文献' },
  'ruc_report': { path: '/detail', moduleCode: 'RDPI_detail_report', listPath: '/list?moduleCode=RDPI_search_jywx', title: '报告', listTitle:'文献' },
  'ruc_article': { path: '/detail', moduleCode: 'RDPI_detail_article', listPath: '/list?moduleCode=RDPI_search_jywx', title: '非正式出版物', listTitle:'文献' },
  /*政策 */
  'ruc_policy': { path: '/detail', moduleCode: 'RDPI_detail_policy', listPath: '/list?moduleCode=RDPI_search_qb_dynamics', title: '政策', listTitle:'情报动态' },
  /*新闻*/ 
  'ruc_news': { path: '/detail', moduleCode: 'RDPI_detail_news', listPath: '/list?moduleCode=RDPI_search_qb_dynamics', title: '新闻', listTitle:'情报动态' },
  /* 机构 */
  'ruc_org_troops': { path: '/detail', moduleCode: 'RDPI_detail_org_troops', listPath: '/list?moduleCode=RDPI_search_org', title: '部队', listTitle:'组织单位' },
  'ruc_org_airport': { path: '/detail', moduleCode: 'RDPI_detail_org_airport', listPath: '/list?moduleCode=RDPI_search_org', title: '机场', listTitle:'组织单位' },
  'ruc_org_camp': { path: '/detail', moduleCode: 'RDPI_detail_org_camp', listPath: '/list?moduleCode=RDPI_search_org', title: '军区', listTitle:'组织单位' },
  'ruc_org_department': { path: '/detail', moduleCode: 'RDPI_detail_org_department', listPath: '/list?moduleCode=RDPI_search_org', title: '部门', listTitle:'组织单位' },
  'ruc_org_hospital': { path: '/detail', moduleCode: 'RDPI_detail_org_hospital', listPath: '/list?moduleCode=RDPI_search_org', title: '医院', listTitle:'组织单位' },
  'ruc_org_port': { path: '/detail', moduleCode: 'RDPI_detail_org_port', listPath: '/list?moduleCode=RDPI_search_org', title: '港口', listTitle:'组织单位' },
  'ruc_org_school': { path: '/detail', moduleCode: 'RDPI_detail_org_school', listPath: '/list?moduleCode=RDPI_search_org', title: '学校', listTitle:'组织单位' },
  'ruc_org_train': { path: '/detail', moduleCode: 'RDPI_detail_org_train', listPath: '/list?moduleCode=RDPI_search_org', title: '火车站', listTitle:'组织单位' },
  'ruc_org_trainbase': { path: '/detail', moduleCode: 'RDPI_detail_org_trainbase', listPath: '/list?moduleCode=RDPI_search_org', title: '军事基地', listTitle:'组织单位' },
  /* 战争战例 */
  'ruc_battle_case': { path: '/detail', moduleCode: 'RDPI_detail_battle_case', listPath: '/list?moduleCode=RDPI_search_battle_case', title: '战争战例', listTitle:'战争战例' },
  /* 视频 +图片--跳转详情时单独处理*/
  'ruc_zx_media': { path: '/detail', moduleCode: 'RDPI_detail_video', listPath: '/list?moduleCode=RDPI_search_media', title: '视频', listTitle:'影像资料' },
  /* 武器 */
  'ruc_weapon': { path: '/detail', moduleCode: 'RDPI_detail_weapon', listPath: '/list?moduleCode=RDPI_search_weapon', title: '武器装备', listTitle:'武器装备' },
  /*军情图谱--事件 */
  'ruc_event': { path: '/detail', moduleCode: 'RDPI_detail_event', listPath: '', title: '事件',listTitle:'' },
}
/* 详情页动态组件名---根据进入详情页的data_type选择对应的页面组件名称 */
export const DETAIL_COM_MAP = {
  /* 机构 */
  'ruc_org_troops': 'organization',
  'ruc_org_airport': 'organization',
  'ruc_org_camp': 'organization',
  'ruc_org_department': 'organization',
  'ruc_org_hospital': 'organization',
  'ruc_org_port': 'organization',
  'ruc_org_school': 'organization',
  'ruc_org_trainstation': 'organization',
  'ruc_org_trainbase': 'organization',
  /* 专家 */
  'ruc_person': 'person',
  /* 文献 */
  'ruc_journal_paper': 'literature',
  'ruc_meeting': 'literature',
  'ruc_degree': 'literature',
  'ruc_report': 'literature',
  'ruc_article': 'literature',
  'ruc_policy': 'policy',
  'ruc_news': 'news',
  // 'ruc_report': 'wx',
  // 'ruc_standard': 'wx',
  // 'ruc_patent': 'wx',
  /* 战例 */
  'ruc_battle_case': 'warExample',
  /* 装备 */
  'ruc_weapon': 'equipment',
  /* 图片 */
  '图片': 'pictures',
  /* 视频 */
  'ruc_zx_media': 'videos',

}
/* 针对数据类型，选取对应的中文和颜色 */
export const WX_TYPE = {
  /* 文献 */
  'ruc_journal_paper': { name: '期刊论文', },
  'ruc_meeting': { name: '会议论文', },
  'ruc_degree': { name: '学位论文', },
  'ruc_report': { name: '报告', },
  'ruc_policy': { name: '政策', },
  'ruc_news': { name: '新闻', },
  'ruc_article': { name: '非正式出版物', },
  /* 战例 */
  'ruc_battle_case': { name: '战例', },
  /* 组织 */
  'ruc_org_troops': { name: '部队', },
  'ruc_org_airport': { name: '机场', },
  'ruc_org_camp': { name: '军区', },//待查证
  'ruc_org_department': { name: '部门', },
  'ruc_org_hospital': { name: '医院', },
  'ruc_org_port': { name: '港口', },//待查证
  'ruc_org_school': { name: '学校', },
  'ruc_org_trainstation': { name: '火车站', },//待查证
  'ruc_org_trainbase': { name: '军事基地', },
  /* 人物 */
  'ruc_person': { name: '人物', },
  /* 装备 */
  'ruc_weapon': { name: '装备', },
  /* 图片 */
  '图片': { name: '图片', },
  /* 视频 */
  'ruc_zx_media': { name: '视频', },
}

/* 标准状态 */
export const BZ_STATUS_OPTIONS = [
  { label: "0", value: "未知" },
  { label: "1", value: "现行" },
  { label: "2", value: "停用" },
  { label: "3", value: "未实施" },
  { label: "4", value: "废除" },
  { label: "5", value: "撤销" },
  { label: "6", value: "被代替" },
  { label: "7", value: "可用" },
]
/* 标准大分类 */
export const BZ_CATEGORY_OPTIONS = [
  { label: "1", value: "国家标准" },
  { label: "2", value: "行业标准" },
  { label: "3", value: "国家军用标准" },
  { label: "4", value: "地方标准" },
  { label: "5", value: "国家计划标准" },
]